<!-- Start About Us Area -->
<div class="about-us-area ptb-100">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-4 col-md-12">
                <div class="about-us-image">
                    <div class="image-two">
                        <img src="assets/images/tab2-frame1.jpg" alt="image">
                    </div>
                </div>
            </div>

            <div class="col-lg-8 col-md-12">

                <div class="about-us-content">


                    <span>Welcome to RoundtableCXO — Where IT Leaders Shape the Conversation. </span>
                    <h2 class="about-us_title">About Us</h2>
                    <p>RoundtableCXO is a peer-driven community designed exclusively for senior IT leaders — including
                        CIOs, CTOs, CISOs, and other domain-specific technology executives. Our events provide a
                        platform for candid discussions, fresh insights, and trusted connections with peers who truly
                        understand the challenges and opportunities of modern IT leadership. </p>
                    <p><b>What makes RoundtableCXO unique?</b> Our roundtable topics come directly from IT leaders like
                        you.
                        Every intimate discussion is shaped by the real-world challenges and interests of local
                        technology
                        executives, ensuring each event is timely, relevant, and impactful. By participating, you’re not
                        just gaining valuable insights — you’re actively contributing to the success of your peers and
                        strengthening the IT leadership community. RoundtableCXO is your platform for building
                        high-value relationships and staying ahead in an ever-evolving tech landscape.</p>
                    <!-- <p>Each event brings together a curated group of technology decision-makers — from global
                        enterprises to high-growth startups — to exchange ideas, explore emerging strategies, and
                        collaborate on solutions that drive business and technology forward. With small, focused guest
                        lists and dynamic discussion formats, we ensure every voice is heard and every connection is
                        meaningful. </p>
                    <p>Whether you’re leading digital transformation, scaling infrastructure, or bridging the gap
                        between IT and business, RoundtableCXO is your platform for building high-value relationships
                        and staying ahead in an ever-evolving tech landscape. </p> -->
                    <p>We look forward to welcoming you to an upcoming roundtable and into our growing community of IT
                        trailblazers. </p>
                    <!-- <ul class="list">
                                <li><i class='bx bx-check'></i> Best Conference Consumer Behavior</li>
                                <li><i class='bx bx-check'></i> Brand Marketing SEO Specilist</li>
                                <li><i class='bx bx-check'></i> Content Marketing and Video Marketing Events</li>
                                <li><i class='bx bx-check'></i> Get Started With Leadership Conference</li>
                            </ul> -->

                    <!-- <div class="about-btn">
                        <a  class="default-btn"> Know More <span></span>
                            </a>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</div>

<app-aboutandeventform></app-aboutandeventform>
